// ISDP CUSTOM — German translation *resources* for Backstage's OWN core/plugin translation refs
// (catalog, techdocs reader chrome, search, user-settings, core-components, etc.).
//
// Our own custom-page namespaces (common.ts, home.ts, …) carry their German inline via each ref's
// `translations` map and do NOT need to be listed here. This array is only for refs we don't define —
// Backstage's — which we override with createTranslationResource({ ref, translations: { de: … } }).
//
// Populated by the core-i18n pass. Anything Backstage/community plugins expose no translation ref for
// is irreducibly English and should be noted rather than forced.
//
// Refs found + overridden (v1.48.0):
//   - coreComponentsTranslationRef  (@backstage/core-components/alpha)     → ./de/backstage-core-components
//   - catalogTranslationRef         (@backstage/plugin-catalog/alpha)      → ./de/backstage-catalog
//   - searchTranslationRef          (@backstage/plugin-search/alpha)       → ./de/backstage-search
//   - userSettingsTranslationRef    (@backstage/plugin-user-settings/alpha)→ ./de/backstage-user-settings
//
// NOT overridden (no reachable public translation ref):
//   - techdocs: @backstage/plugin-techdocs exposes only a private `techdocsTranslationRef` with the
//     single key aboutCard.viewTechdocs (not re-exported from its public/alpha entry). The TechDocs
//     reader chrome (header title, "Table of contents", search box, footer) is rendered by mkdocs-
//     generated HTML + plugin-techdocs-react (which has no translation ref), so those strings are
//     irreducibly English via this mechanism.
import type { TranslationResource } from '@backstage/core-plugin-api/alpha';
import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export const backstageTranslationResources: TranslationResource[] = [
  createTranslationResource({
    ref: coreComponentsTranslationRef,
    translations: { de: () => import('./de/backstage-core-components') },
  }),
  createTranslationResource({
    ref: catalogTranslationRef,
    translations: { de: () => import('./de/backstage-catalog') },
  }),
  createTranslationResource({
    ref: searchTranslationRef,
    translations: { de: () => import('./de/backstage-search') },
  }),
  createTranslationResource({
    ref: userSettingsTranslationRef,
    translations: { de: () => import('./de/backstage-user-settings') },
  }),
];
